export default "__VITE_ASSET__BOO4XyAN__"